import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';

import {
    ValidatedDate,
    ValidatedTime,
    startDateConnector,
    startTimeConnector,
    endDateConnector,
    endTimeConnector,
} from '@eb/react-redux-form-datetime-pair';

import {
    MIN_EVENT_START_DATE,
    MAX_EVENT_START_DATE,
    getPrefixedStartDateName,
    getPrefixedEndDateName,
    getPrefixedStartTimeName,
    getPrefixedEndTimeName,
    DATE_LABELS,
} from './constants';

export default class EventDateTimePair extends Component {
    static propTypes = {
        getFormState: PropTypes.func.isRequired,
        labels: PropTypes.shape({
            startDate: EBPropTypes.translation.isRequired,
            startTime: EBPropTypes.translation.isRequired,
            endDate: EBPropTypes.translation.isRequired,
            endTime: EBPropTypes.translation.isRequired,
        }),
        prefix: PropTypes.string.isRequired,
        required: PropTypes.bool,
        contentAfterStartTime: PropTypes.node,
    };

    static defaultProps = {
        labels: DATE_LABELS,
    };

    componentWillMount() {
        const { getFormState, prefix } = this.props;
        const prefixOption = { prefix };
        const startTimeOptions = {
            ...prefixOption,
            setRelativeMinTime: true,
        };

        this._wiredComponents = {
            StartDate: startDateConnector(
                ValidatedDate,
                getFormState,
                prefixOption,
            ),
            StartTime: startTimeConnector(
                ValidatedTime,
                getFormState,
                startTimeOptions,
            ),
            EndDate: endDateConnector(
                ValidatedDate,
                getFormState,
                prefixOption,
            ),
            EndTime: endTimeConnector(ValidatedTime, getFormState, prefix),
        };
    }

    render() {
        const { labels, prefix, required, contentAfterStartTime } = this.props;

        const {
            StartDate,
            StartTime,
            EndDate,
            EndTime,
        } = this._wiredComponents;

        const startDateName = getPrefixedStartDateName(prefix);
        const endDateName = getPrefixedEndDateName(prefix);
        const startTimeName = getPrefixedStartTimeName(prefix);
        const endTimeName = getPrefixedEndTimeName(prefix);

        const dateContainerClass = classNames(
            'eds-g-cell',
            'eds-g-cell--has-overflow',
            'eds-l-pad-right-2',
            {
                'eds-g-cell-12-12 eds-g-cell-sm-6-12': !contentAfterStartTime,
                'eds-g-cell-12-12 eds-g-cell-sw-4-12': contentAfterStartTime,
            },
        );

        let contentAfterStartTimeContainer;

        if (contentAfterStartTime) {
            contentAfterStartTimeContainer = (
                <div className={dateContainerClass}>
                    {contentAfterStartTime}
                </div>
            );
        }

        return (
            <div data-spec="event-date-time-pair">
                <div className="eds-g-grid eds-l-mar-top-5 eds-l-mar-bot-2">
                    <div className="eds-g-group">
                        <div className={dateContainerClass}>
                            <StartDate
                                id={startDateName}
                                name={startDateName}
                                label={labels.startDate}
                                minDate={MIN_EVENT_START_DATE}
                                maxDate={MAX_EVENT_START_DATE}
                                required={required}
                            />
                        </div>
                        <div className={dateContainerClass}>
                            <StartTime
                                id={startTimeName}
                                name={startTimeName}
                                label={labels.startTime}
                                hideLabel={true}
                                required={required}
                            />
                        </div>
                        {contentAfterStartTimeContainer}
                    </div>
                </div>
                <div className="eds-g-grid eds-l-mar-bot-2">
                    <div className="eds-g-group">
                        <div className={dateContainerClass}>
                            <EndDate
                                id={endDateName}
                                name={endDateName}
                                label={labels.endDate}
                                isEndInput={true}
                                required={required}
                            />
                        </div>
                        <div className={dateContainerClass}>
                            <EndTime
                                id={endTimeName}
                                name={endTimeName}
                                label={labels.endTime}
                                required={required}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
